const pt = {
  layout: {
    cos_button: {
      phone: 'Telefone',
      update_phone_number_message: 'Número de telefone atualizado com sucesso!'
    },
    time: {
      days: 'Dias',
      hours: 'Horas',
      mins: 'Minutos',
      secs: 'Segundos',
      starts: 'Inicia',
      starts_immediately: 'Inicia imediatamente'
    },
    field: {
      host: 'Anfitrião'
    },
    copy: 'Copiar'
  },
  validations: {
    email: 'Deve ser um e-mail válido',
    phone: 'Deve ser um telefone válido',
    required_field: 'É um campo obrigatório'
  },
  mailer: {
    need_help: 'Precisa de Ajuda?',
    stop_reminders: 'Parar de receber lembretes',
    cancel_registration: 'Cancelar registro',
    report_abuse: 'Denunciar abuso'
  },
  datetime: {
    no_sessions: 'Nenhuma sessão disponível',
    empty_label: 'Data/Hora'
  },
  errors: {
    verification_failed: 'A verificação falhou. Por favor, tente novamente.',
    session_unavailable: 'O horário que você selecionou não está mais disponível. Escolha outro horário de sessão.',
    challenge_email_mismatch: 'Cadastre-se com o mesmo e-mail que você usou para se inscrever no evento.'
  }
}

export default pt
